import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigService } from '../../helpers/config.service';
import { CompanyProfileService } from '../../features/Company-Admin/company-admin-profile/services/company-profile.service';
import { MatDialog } from '@angular/material/dialog';
import { SuccessTrancactionComponent } from '../../features/Company-Admin/company-admin-profile/charge-wallet/success-trancaction/success-trancaction.component';

@Component({
  selector: 'app-payment-confirmation-page',
  templateUrl: './payment-confirmation-page.component.html',
  styles: [
  ]
})
export class PaymentConfirmationPageComponent implements OnInit {

  dataLoading = false;
  paymentId = null;
  paymentToken: string = '';

  showErrorMessage: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private _config: ConfigService,
    private _companyProfileService: CompanyProfileService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    // this.location.
    this.activatedRoute.queryParams.subscribe((params: any) => {
      if (params.id) {
        this.paymentId = params.id;
      }
    });
    this.paymentToken = this.activatedRoute.snapshot.params['token'];
    console.log(this.paymentId, this.paymentToken);
    this.getDataToPaymentGetway()
  }

  getDataToPaymentGetway() {
    this.dataLoading = true;
    this._companyProfileService.ConfirmWalletTransAction(this.paymentToken).subscribe(
      (res) => {
        if (res) {
          // this._config.SusseccMessage(res.message)
          this.openSuccessMessage(res.data);
          this.goToCpmapanyProfile()
        }
      },
      (err) => {
        this.dataLoading = false;
        this.showErrorMessage = true;
        this.goToCpmapanyProfile()
      }
    );

  }


  goToCpmapanyProfile() {
    this._config.goTo('admin/company-admin-profile')
  }

  openSuccessMessage(data: any) {
    const dialogRef = this.dialog.open(SuccessTrancactionComponent, {
      width: "540px",
      data: data
    })
  }

}
